import { get } from '@bigyouth/base'
import SplitType from 'split-type'

export default {
  name: 'hp-hero',

  ui: {
    video: '[js-hp-hero-video]',
    wrap: '[js-hp-hero-wrap]',
    slider: '[js-hp-hero-slider]',
    content: '[js-hp-hero-content]',
    title: '[js-hp-hero-title]',
  },

  componentDidMount () {
    const header = get('.header')

    if (window.innerWidth >= 768) {
      this.ui.video.setAttribute('autoplay', '')
      this.el.classList.add('is-visible')

      this.ui.wrap.classList.remove('md:hidden')

      setTimeout(() => {
        header.classList.add('is-visible')
      }, 700)

      setTimeout(() => {
        this.ui.slider.classList.add('is-visible')
        this.title = new SplitType(this.ui.title, { types: 'words, lines' })
      }, 1300)

      setTimeout(() => {
        this.ui.content.classList.add('is-visible')
      }, 1900)
    }
  },
}
